import CurrentUser from "./CurrentUser";
import Users from "./Users";

const AccessControlPanel = {
  CurrentUser,
  Users,
};

export default AccessControlPanel;
